// extracted by mini-css-extract-plugin
export default {"infoBar":"IsaacPills_infoBar__oxnMu"};